// Copyright (c) 2016 Deere & Company

import './basic-warranty-estimator-report.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import BasicWarrantyEstimator from '@deere/cps-it.warranty-model-factory/lib/basic-warranty-estimator';
import BasicWarrantyEstimatorReportCriteria from './basic-warranty-estimator-report-criteria';
import Criteria from '../state/criteria';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import Formatting from '../state/formatting';
import GeneralSettings from '@deere/cps-it.warranty-model-factory/lib/general-settings';
import InlineAlertBar from '../../../shared/components/inline-alert-bar/index';
import NumberOfRecordsFound from '../../../shared/components/number-of-records-found/index';
import ReportGrid from '../../shared/components/report-grid';
import ReportHeader from '../../shared/components/report-header';
import ReportHiddenColumns from '../../shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import View from '../state/view';
import WarrantyAgGridDatePicker from '../../shared/components/ag-grid-date-picker';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToCSV} from '../../../reports/shared/services/export-to-csv';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getBasicWarrantyColumnDefinitions} from '../report-services/column-definitions';
import {getDefaultReportLayout} from '../../shared/services/report-variant';
import {scrollToAndResizeReport} from '../../shared/services/scroll-window';

function handlePinTpDisplayChange(event) {

    const updatedPinValue = event.target.value;

    this.actions.updateBasicWarrantyEstimatorPinCriteria(updatedPinValue);

}

function handleSelectAllDealers() {

    this.actions.selectAllBasicWarrantyEstimatorDealers(this.selectedAccounts);

}

function handleDealerSelect(index, isSelected) {

    this.actions.selectBasicWarrantyEstimatorDealer(index, isSelected);

}

function handleCreateReportClick() {

    this.actions.toggleReportIsScrollable();
    this.actions.resetSearchResults();
    this.actions.createBasicWarrantyEstimatorReport();

}

function handleGridApiDefinition(params) {

    let defaultColumnState,
        defaultSortModel;

    this.actions.createAgGridApi(params.api, params.columnApi);

    if (this.selectedLayout && this.selectedLayout.name && !this.isInitialLoad) {

        const defaultLayout = this.layouts.find(layout => !layout.name);

        defaultColumnState = defaultLayout.columnState;
        defaultSortModel = defaultLayout.sortModel;

    } else {

        defaultColumnState = params.columnApi.getColumnState();
        defaultSortModel = params.api.getSortModel();

        this.actions.updateReportProperty('isInitialLoad', false);

    }

    this.actions.updateDefaultLayout(defaultColumnState, defaultSortModel);

    if (this.selectedLayout && this.selectedLayout.name) {

        params.columnApi.setColumnState(this.selectedLayout.columnState);
        params.api.setSortModel(this.selectedLayout.sortModel);
        params.api.setFilterModel(this.selectedLayout.filterModel);

    } else {

        const defaultLayout = getDefaultReportLayout(defaultColumnState, defaultSortModel);

        this.actions.updateReportProperty('selectedLayout', defaultLayout);

    }

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

function handleExportToCsv() {

    const fileName = 'basic-warranty-estimator';

    return exportToCSV(fileName, this.gridApi);

}

function handleCriteriaReset() {

    this.actions.updateBasicWarrantyEstimatorPinCriteria('');
    this.actions.selectAllDealersOnLoad(this.selectedAccounts);
    this.actions.resetSearchResults();
    this.actions.updateShowNoResultsFound(false);

}

class BasicWarrantyEstimatorReport extends Component {

    componentWillMount() {

        this.props.actions.selectAllDealersOnLoad(this.props.selectedAccounts);
        this.props.actions.getReportLayouts('basic-warranty-estimator');

    }

    componentDidUpdate(prevProps) {

        if (this.props.reportIsScrollable && this.props.report.length) {

            this.props.actions.resetReportIsScrollable();

            scrollToAndResizeReport();

        }

        const isFirstRun = !prevProps.report.length && !prevProps.showNoResultsFound;
        const layoutWasChanged = this.props.selectedLayout !== prevProps.selectedLayout;
        const readyToApplyLayout = this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable;

        if ((isFirstRun || layoutWasChanged) && readyToApplyLayout) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetSearchResults();
        this.props.actions.updateShowNoResultsFound(false);
        this.props.actions.resetReportVariant();

    }

    render() {

        const canRunReport = this.props.selectedDealers.length > 0 && this.props.criteria.pin.length > 0;

        const gridOptions = {
            dateComponentFramework: WarrantyAgGridDatePicker
        };

        return (
            <section className='basic-warranty-estimator'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <h2 className='basic-warranty-estimator-title'>
                    <FormattedMessage id='BASIC_WARRANTY_ESTIMATOR'/>
                    <FavoriteIcon
                        id='BASIC_WARRANTY_ESTIMATOR'
                        route={this.props.pathName}
                    />
                </h2>
                <BasicWarrantyEstimatorReportCriteria
                    canExport={this.props.report.length > 0}
                    canRunReport={canRunReport}
                    onCreateReport={this.props::handleCreateReportClick}
                    onCriteriaReset={this.props::handleCriteriaReset}
                    onDealerSelect={this.props::handleDealerSelect}
                    onExportToCsv={this.props::handleExportToCsv}
                    onPinCriteriaChange={this.props::handlePinTpDisplayChange}
                    onSelectAllDealers={this.props::handleSelectAllDealers}
                    pin={this.props.criteria.pin}
                    selectedAccounts={this.props.selectedAccounts}
                    selectedDealers={this.props.selectedDealers}
                />
                <InlineAlertBar label='ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED'/>
                {this.props.report.length ?
                    <div>
                        <NumberOfRecordsFound count={this.props.report.length}/>
                        <section className='report'>
                            {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
                            <ReportHeader
                                columnApi={this.props.columnApi}
                                gridApi={this.props.gridApi}
                                reportName='basic-warranty-estimator'
                            />
                            <ReportGrid
                                columnDefs={getBasicWarrantyColumnDefinitions()}
                                gridOptions={gridOptions}
                                localeText={getAgGridLocaleText()}
                                onColumnVisible={this.props::onColumnRemoved}
                                onGridReady={this.props::handleGridApiDefinition}
                                rowData={this.props.report}
                            />
                        </section>
                    </div> :
                    <ShowNoResultsFound showNoResultsFound={this.props.showNoResultsFound}/>
                }
            </section>
        );

    }

}

BasicWarrantyEstimatorReport.displayName = 'BasicWarrantyEstimatorReport';
BasicWarrantyEstimatorReport.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    formatting: PropTypes.instanceOf(Formatting).isRequired,
    generalSettings: PropTypes.instanceOf(GeneralSettings).isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    pathName: PropTypes.string.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(BasicWarrantyEstimator)),
    reportIsScrollable: PropTypes.bool.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showNoResultsFound: PropTypes.bool.isRequired,
    views: PropTypes.arrayOf(PropTypes.instanceOf(View)).isRequired
};

export default BasicWarrantyEstimatorReport;



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/components/basic-warranty-estimator-report.js